import { render } from "./AppInstaram.vue?vue&type=template&id=4dc07bc0"
import script from "./AppInstaram.vue?vue&type=script&lang=js"
export * from "./AppInstaram.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__